import type {
  AdminOverlayDefinition,
  AdminViewDefinition,
} from "../../components/admin-components.js";
import {
  card,
  drawer,
  modal,
  withDrawer,
  withModal,
} from "../_shared/overlay-definition-helpers.js";

export const installationOverlayViews: AdminViewDefinition[] = [
  withModal("suspend-store", "store-detail-overview", suspendStoreModal()),
  withModal("resume-store", "store-detail-overview", resumeStoreModal()),
  withModal("start-support-session", "store-detail-overview", startSupportSessionModal()),
  withModal("end-support-session", "support-session-active", endSupportSessionModal()),
  withDrawer("support-session-activity", "support-session-active", supportSessionActivityDrawer()),
];

function suspendStoreModal(): AdminOverlayDefinition {
  return modal(
    "Suspend store?",
    [
      card("Suspension", ["Provide a support reason and type CONFIRM to proceed."]),
      card("Notifications", [
        "Owners and App Admins - Notify",
        "Storefront requests - Paused",
        "Automatic offers - Paused",
      ]),
    ],
    [{ label: "Cancel" }, { label: "Suspend store", variant: "danger" }],
  );
}

function resumeStoreModal(): AdminOverlayDefinition {
  return modal(
    "Resume store?",
    [card("Resume validation", ["Provide a support reason and type CONFIRM to proceed."])],
    [{ label: "Cancel" }, { label: "Resume store", variant: "primary" }],
  );
}

function startSupportSessionModal(): AdminOverlayDefinition {
  return modal(
    "Start support access?",
    [card("Time-bound support access", ["Access is audited and expires automatically."])],
    [{ label: "Cancel" }, { label: "Start support access", variant: "primary" }],
  );
}

function endSupportSessionModal(): AdminOverlayDefinition {
  return modal(
    "End support session unavailable",
    [
      card("Current status", [
        "Starting support access is wired through the store detail API.",
        "Ending support sessions from this overlay does not have a backend API yet.",
      ]),
      card("Required backend contract", [
        "Support access ID",
        "Closure reason",
        "Reason-coded audit record",
        "Session-state refresh after closure",
      ]),
    ],
    [
      { label: "Keep session open" },
      {
        label: "End session",
        variant: "danger",
        disabled: true,
        disabledReason: "Ending support sessions from this overlay is not wired yet.",
      },
    ],
  );
}

function supportSessionActivityDrawer(): AdminOverlayDefinition {
  return drawer(
    "Support session activity unavailable",
    "A live support-session activity endpoint is not implemented yet.",
    [
      card("Current status", [
        "The Admin store detail API can start support access.",
        "This drawer intentionally does not show sample support-session activity.",
      ]),
      card("Required backend contract", [
        "Support access ID",
        "Reason-coded activity rows",
        "Admin-safe read/mutation summaries",
        "No protected customer data, credentials, cookies, tokens, or raw payloads",
      ]),
    ],
  );
}
